import React, { useState } from "react";
import SiteWrapper from "../../../../SiteWrapper.react";
import DashboardWTI from "./WTI";


const MainWTI = () => {

    return (
        <SiteWrapper>
                <div className="container otd-container wti-dashboard">
                    <DashboardWTI
                    />
                  </div>
            
        </SiteWrapper>
    );
};

export default MainWTI;